export const PostForm = {
  DATE: 'date',
  LOCATION: 'location',
  CATEGORY: 'category'
} as const;

export type PostForm = (typeof PostForm)[keyof typeof PostForm];
